import React, { useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import PedidosList from "../../../components/PedidosList";
import PedidoDetails from "../../../components/PedidoDetails";
import PedidoNew from "../../../components/PedidoNew";
import { MobileContext } from "../Mobile";

const drawerWidth = "100vw";

const useStyles = makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#fafafa"
  }
}));

const Pedidos = () => {
  const classes = useStyles();
  const { pedidosView, onClosePedidos } = useContext(MobileContext);
  const [pedido, setPedido] = useState(null);
  const [nuevoPedido, setNuevoPedido] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(null);

  const vistaNuevoPedido = value => {
    setPedido(null);
    setNuevoPedido(value);
  };

  const vistaPedido = value => {
    setNuevoPedido(null);
    setPedido(value);
  };

  const handleCreate = () => {
    setNuevoPedido(null);
    setPedido(null);
    setShouldFetch(new Date().toString());
  };

  return (
    <>
      <Drawer
        className={classes.drawer}
        open={Boolean(pedido)}
        anchor="right"
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <PedidoDetails
          mobile
          pedido={pedido}
          onClose={() => setPedido(null)}
          onUpdate={setPedido}
        />
      </Drawer>

      <Drawer
        className={classes.drawer}
        open={Boolean(nuevoPedido)}
        anchor="right"
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <PedidoNew mobile onCreate={handleCreate} onClose={() => setNuevoPedido(null)} />
      </Drawer>

      <Drawer
        className={classes.drawer}
        open={pedidosView.open}
        anchor="right"
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <PedidosList
          tipo={pedidosView.tipo}
          selected={pedido}
          onBack={onClosePedidos}
          onSelect={vistaPedido}
          onNuevoPedido={vistaNuevoPedido}
          shouldFetch={shouldFetch}
        />
      </Drawer>
    </>
  );
};

export default Pedidos;
